import styled from "styled-components";

import { flexCenter, rem } from "@styles/Utilities.styled";


export const StyledErrorFallback = styled.div`
  ${flexCenter}
  flex-direction: column;
  min-height: 100vh;

  .content {
    max-width: ${rem(500)};
    padding: 2rem;
    background-color: var(--clr-white);
    border-radius: 8px;
    border: 1px solid var(--mantine-color-gray-3);
  }

  .logo {
    width: min(50%, ${rem(300)});
    margin-inline: auto;
  }

  .heading {
    font-size: ${rem(22)};
    font-weight: 600;
    margin-top: 1.5rem;
    text-align: center;
  }

  .description {
    margin-top: 1rem;
    text-align: center;
    font-size: ${rem(15)};
  }

  .cta {
    display: flex;
    padding: 0.5rem 1.25rem;
    margin-top: 2rem;
    color: var(--clr-white);
    background-color: var(--mantine-color-primary-4);
    font-size: ${rem(15)};
    margin-inline: auto;
    border-radius: 5px;
  }

  .error {
    margin-top: 2rem;
  }

  .support {
    color: var(--mantine-color-gray-6);
    font-size: ${rem(14)};
    margin-top: 1rem;
    font-weight: 500;
  }
`;
